import { ApplicationConfig, provideZoneChangeDetection, provideAppInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalBroadcastService,
  MsalGuard,
  MsalService,
} from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
} from './auth/msal.config';
import { TokenRefreshInterceptor } from './auth/token-refresh.interceptor';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    ...(
      environment.playwrightAuthBypass
        ? []
        : [
            { provide: HTTP_INTERCEPTORS, useClass: TokenRefreshInterceptor, multi: true },
          ]
    ),
    // Initialize MSAL before the app starts
    provideAppInitializer(() => {
      const msalService = inject(MsalService);

      // Handle redirect responses globally once during startup so routes and
      // guards always see the settled MSAL state before they run.
      return firstValueFrom(msalService.handleRedirectObservable());
    }),
  ],
};
